(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[90363,33124],{

/***/ 14593:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quoto",
      function () {
        return __webpack_require__(57104);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ QuotoHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_layouts_quotoWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4080);
/* harmony import */ var _components_quoto_mainBanner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17427);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _components_shared_offersList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33124);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88737);







const SimpleProcess = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 15027).then(__webpack_require__.bind(__webpack_require__, 15027)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(15027)
            ]
    }
});
var __N_SSP = true;
function QuotoHome() {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_6__/* .useDomainContext */ .w)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_quotoWrapper__WEBPACK_IMPORTED_MODULE_2__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_quoto_mainBanner__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "offers",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_offersList__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    offers: domain?.defaultOffers,
                    style: {}
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SimpleProcess, {})
        ]
    });
}


/***/ }),

/***/ 33124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ OffersList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75094);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88737);







const Banner = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(()=>Promise.all(/* import() */[__webpack_require__.e(3294), __webpack_require__.e(27602)]).then(__webpack_require__.bind(__webpack_require__, 27602)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(27602)
            ]
    }
});
function OffersList({ offers , style , fullWidth =false , showInForm =false , zone  }) {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_5__/* .useDomainContext */ .w)();
    const showListAbove = !(0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .finalShowForm */ .r6)(router.query.sl, domain.showForm, domain.defaultOffers);
    if (Array.isArray(offers) && offers.length) {
        const keyword = router.query?.k;
        const orderedListOffers = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .orderListByKeyword */ .h2)(keyword, offers.filter((item)=>item?.placements?.skipMainOffersList !== true));
        if (!showInForm && showListAbove) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
        }
        return (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .getOffersByPlacement */ .um)(orderedListOffers, "offersList")?.map((offer, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Banner, {
                offer: offer,
                style: style ?? undefined,
                displayLinkAndPhoneNumber: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .doesOfferHaveALink */ .hn)(offer),
                fullWidth: fullWidth,
                zone: zone
            }, index));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,76526,87001,49774,92888,40179], function() { return __webpack_exec__(14593); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);